import script from "./OrderTablePreviewNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderTablePreviewNew.vue?vue&type=script&lang=ts&setup=true"

import "./OrderTablePreviewNew.vue?vue&type=style&index=0&id=2307321b&lang=scss"

const __exports__ = script;

export default __exports__